import posthog from 'posthog-js';
import { registerPosthog } from './registerPosthog';

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: 'identified_only',
  loaded: registerPosthog,
});
